import { combineReducers } from "redux";
import profileReducer from './profile/index';

const rootReducer = combineReducers({
  profileReducer
});

export default rootReducer;